import { h } from 'preact';
import { Tabs, Tab } from '@cube/blocks';
import IncomeStatement from '../stock-data-table/income-statement';
import CashFlow from '../stock-data-table/cash-flow';
import BalanceSheet from '../stock-data-table/balance-sheet';
import style from './style';
import { Text } from 'preact-i18n';

const INTL_NS = 'financial-details-tabs';

const TAB_ITEMS = [
	{ title: <Text id={`${INTL_NS}.incomeStatement`} />, ComponentClass: IncomeStatement },
	{ title: <Text id={`${INTL_NS}.cashFlow`} />, ComponentClass: CashFlow },
	{ title: <Text id={`${INTL_NS}.balanceSheet`} />, ComponentClass: BalanceSheet }
];

export default function FinancialDetailsPanel({ timespan, ...props }) {
	return  (
		<Tabs class={style.tabs}>
			{TAB_ITEMS
				.map(({ title, ComponentClass }) => (
					<Tab title={title}>
						<ComponentClass timespan={timespan} {...props} />
					</Tab>
				))
			}
		</Tabs>
	);
}
